import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { FuncionalidadControl } from '../../_models/funcionalidad-control';
import { ConfirmationService, SelectItem } from 'primeng/api';
import { NavService } from '../../_services/_nav.service';
import { ProductoEstadoRelacionService } from '../../_services/producto-estado-relacion.service';
import { ListaService } from '../../_services/lista.service';
import { ProductoEstadoRelacionCausalService } from '../../_services/producto-estado-relacion-causal.service';
import { TipoCausalCausalSolicitudService } from '../../_services/tipo-causal-causal-solicitud.service';
import { FuncionalidadesService } from '../../_services/funcionalidades.service';
import { ProductoEstadoRelacionNotificacionService } from '../../_services/producto-estado-relacion-notificacion.service';
import { NotificacionesService } from '../../_services/notificaciones.service';
import { forkJoin } from 'rxjs';
import { CanalService } from '../../_services/canal.service';
import { EstadoService } from '../../_services/estado.service';
import { ConfiguracionesCanales } from '../../_models/configuraciones-canales';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { ConfiguracionesCanalesService } from '../../_services/configuraciones-canales.service';
import { Location } from '@angular/common';
import moment from 'moment';
import 'moment/locale/es';
import { FlujoVentaPaso } from '../../_models/flujo-venta-paso';
import { ConfiguracionCanalFlujoVentaPaso } from '../../_models/configuracion-canal-flujo-venta-paso';
import { FlujoVentaPasoService } from '../../_services/flujo-venta-paso.service';
import { ConfiguracionCanalFlujoVentaPasoService } from '../../_services/configuracion-canal-flujo-venta-paso.service';
import { Pasos } from '../../_enums/enum';
import { FlujoVentaPasoControlService } from '../../_services/flujo-venta-paso-control.service';
import {FlujoVentaPasoControl} from '../../_models/flujo-venta-paso-control';

@Component( {
  selector: 'app-canal-estado-paso',
  templateUrl: 'canal-estado-paso.component.html'
} )

export class CanalEstadoPasoComponent implements OnInit {

  @Input() configuracionCanal: ConfiguracionesCanales;
  @Input() editar: true;

  formularioPasos: FormGroup;
  submitted = false;
  guardando = false;
  columnas: any[];
  carInformacionInicial = true;
  listaFuncionalidadesControles: FuncionalidadControl[] = [];
  listaPasosFlujoVenta: FlujoVentaPaso[] = [];
  listaPasos: SelectItem[] = [];
  listaPasosCanal: ConfiguracionCanalFlujoVentaPaso[] = [];
  listaPasosCanalTodos: ConfiguracionCanalFlujoVentaPaso[] = [];
  carTabla = true;
  showTable = false;
  pasoDatbas: FlujoVentaPaso;
  pasoFinpro: FlujoVentaPaso;
  configCanalPasoEditar: ConfiguracionCanalFlujoVentaPaso;
  configCanalPasoControl: ConfiguracionCanalFlujoVentaPaso;
  showConfigControls = false;
  cargandoControles = false;
  faltaConfigurarPaso = false;

  pasoPolitica = false;
  listaFlujoVentaPasoControl: FlujoVentaPasoControl[];
  anchoPantalla: number;
  altoPantalla: number;
  anchoMedidaModal: number;
  altoMedidaModal: number;
  medidaModal: any;

  get fControls() {
    return this.formularioPasos.controls;
  }

  constructor( private navServicio: NavService,
               private conServicio: ConfirmationService,
               private proEstadoCambioServicio: ProductoEstadoRelacionService,
               private fb: FormBuilder,
               private lisServicio: ListaService,
               private proEstadoRelacionCausalServicio: ProductoEstadoRelacionCausalService,
               private tipCausalesService: TipoCausalCausalSolicitudService,
               private funServicio: FuncionalidadesService,
               private proEstadoRelacionNotificacionServicio: ProductoEstadoRelacionNotificacionService,
               private notServicio: NotificacionesService,
               private canalService: CanalService,
               private estadoService: EstadoService,
               private activeRoute: ActivatedRoute,
               private configCanalService: ConfiguracionesCanalesService,
               private location: Location,
               private fluVentaPasoService: FlujoVentaPasoService,
               private canalPasoService: ConfiguracionCanalFlujoVentaPasoService,
               private fluVentaPasoControlService: FlujoVentaPasoControlService) {
  }

  ngOnInit(): void {
    this.anchoPantalla = window.innerWidth;
    this.altoPantalla = window.innerHeight;
    this.anchoMedidaModal = (this.anchoPantalla - (this.anchoPantalla * 0.1));
    this.altoMedidaModal = (this.altoPantalla - (this.altoPantalla * 0.27));
    this.medidaModal = {'width': this.anchoMedidaModal + 'px', 'max-height': this.altoMedidaModal + 'px'};
    this.cargarEncabezadoTabla();
    this.cargarDatos();
  }

  cargarEncabezadoTabla() {
    this.columnas = [
      { field: 'flujoVentaPaso', header: this.navServicio.buscarMensaje( 'CONFIGURACIONCANALESESTADO.LBL_PASO' ), sort: true },
      { field: 'indicadorObligatorio', header: this.navServicio.buscarMensaje( 'CONFIGURACIONCANALESESTADO.LBL_OBLIGATORIO' ), sort: true },
      { field: 'det', header: this.navServicio.buscarMensaje( 'LBL_ACCIONES' ), sort: false }
    ];
  }

  cargarDatos() {

    forkJoin(
      this.fluVentaPasoService.listadoHabilitados(),
      this.fluVentaPasoControlService.listadoHabilitados()
    ).subscribe(async ([pasosFlujoVenta, flujoVentaPasoControl]) => {
      this.listaPasosFlujoVenta = pasosFlujoVenta;
      this.listaFlujoVentaPasoControl = flujoVentaPasoControl;
      this.pasoDatbas = this.listaPasosFlujoVenta.find( x => x.codigo === Pasos.DATOSBASICOS );
      this.pasoFinpro = this.listaPasosFlujoVenta.find( x => x.codigo === Pasos.FINPROCESO );
      if ( !this.pasoDatbas || !this.pasoFinpro ) {
        // this.showMessage('LBL_INFORMACION', 'CONFIGURACIONCANALESESTADO.MSG_FALTACONFIGURACIONPASO');
        this.carInformacionInicial = false;
        this.faltaConfigurarPaso = true;
        return;
      }
      await this.cargarItemsValidos();
    });
  }

  cargarItemsValidos() {
    this.showTable = false;
    this.canalPasoService.listadoPorId(this.configuracionCanal.idConfiguracionCanal).subscribe( async pasosCanal => {
      this.listaPasosCanalTodos = pasosCanal;
      this.listaPasosCanal = pasosCanal.filter( x => x.indicadorHabilitado);
      await this.guardarPasosDatbasFinpro();

      this.listaPasos = [];
      this.listaPasosFlujoVenta.map( pfv => {
        const existeHabilitado = this.listaPasosCanal.find( x => x.idFlujoVentaPaso === pfv.idFlujoVentaPaso );
        if ( !existeHabilitado && pfv.idFlujoVentaPaso !== this.pasoDatbas.idFlujoVentaPaso && pfv.idFlujoVentaPaso !== this.pasoFinpro.idFlujoVentaPaso ) {
          const item = { label: pfv.nombre, value: pfv.idFlujoVentaPaso };
          this.listaPasos.push(item);
        }
      });
      this.cargarFormulario();
      this.carInformacionInicial = false;
      this.showTable = true;
      this.carTabla = false;
    });
  }

  cargarFormulario() {
    this.formularioPasos = this.fb.group( {
      idFlujoVentaPaso: [ this.configCanalPasoEditar ? [ this.configCanalPasoEditar.idFlujoVentaPaso ] : null, [Validators.required] ],
      indicadorObligatorio: [ this.configCanalPasoEditar ? [ this.configCanalPasoEditar.indicadorObligatorio ] : false ]
    } );
  }

  onSubmit() {
    this.submitted = true;
    if ( this.formularioPasos.valid ) {
      this.conServicio.confirm( {
        message: this.navServicio.buscarMensaje( 'CONFIGURACIONCANALESESTADO.MSG_GUARDARPASO' ),
        header: this.navServicio.buscarMensaje( 'LBL_CONFIRMACION' ),
        icon: 'fa fa-question-circle',
        accept: () => {
          this.guardarPasosConfiguracionCanal();
        },
        reject: () => {
        }
      } );
    }
  }

  guardarPasosConfiguracionCanal() {
    this.guardando = true;
    const pasosEscogidosCanal = this.fControls.idFlujoVentaPaso.value;
    const listaGuardar = this.armarListaBulk(pasosEscogidosCanal);
    this.canalPasoService.bulk( listaGuardar ).subscribe( async resp => {
      this.showMessage('LBL_INFORMACION', 'Se han actualizado los pasos de la configuración del canal de forma exitosa!', 'success');
      this.submitted = false;
      this.guardando = false;
      await this.cargarItemsValidos();
    }, e => {
      this.guardando = false;
    });
  }

  armarListaBulk(idPasosEscogidos: string[], precargaPasos = false) {
    const listaBulk = [];
    idPasosEscogidos.map( idPaso => {
      const existeInhabilitado = this.listaPasosCanalTodos.find( x => x.idFlujoVentaPaso === idPaso );
      const objGuardar = {
        idConfiguracionCanalFlujoVentaPaso: existeInhabilitado ? existeInhabilitado.idConfiguracionCanalFlujoVentaPaso : null,
        idFlujoVentaPaso: idPaso,
        idConfiguracionCanal: this.configuracionCanal.idConfiguracionCanal,
        indicadorObligatorio: precargaPasos ? precargaPasos : this.fControls.indicadorObligatorio.value,
        indicadorHabilitado: true,
        auditoriaFecha: new Date(moment().format())
      } as ConfiguracionCanalFlujoVentaPaso;

      listaBulk.push(objGuardar);
    });
    return listaBulk;
  }

  private showMessage( titulo: string, mensaje: string, severity: string = 'info' ) {
    this.navServicio.setMesage( 0, {
      severity: severity, summary: this.navServicio.buscarMensaje( titulo ),
      detail: this.navServicio.buscarMensaje( mensaje )
    } );
  }

  async guardarPasosDatbasFinpro() {
    // VALIDAR QUE LOS PASOS PREDEFINIDOS NO ESTEN YA AGREGADOS
    const agregados = this.listaPasosCanal.filter( x => x.idFlujoVentaPaso === this.pasoDatbas.idFlujoVentaPaso || x.idFlujoVentaPaso === this.pasoFinpro.idFlujoVentaPaso );
    if ( agregados.length === 2 ) {
      return;
    }

    const idsObligatorios = [];
    if ( this.pasoDatbas && this.pasoFinpro ) {
      idsObligatorios.push(this.pasoDatbas.idFlujoVentaPaso);
      idsObligatorios.push(this.pasoFinpro.idFlujoVentaPaso);
    }
    if ( idsObligatorios.length === 0 ) {
      console.log(this.pasoDatbas);
      console.log(this.pasoFinpro);
      console.log('No estan configurados los pasos DATBAS y FINPRO o hubo un error en la obtención de los mismos');
      return;
    }

    const pasosObligatorios = this.armarListaBulk(idsObligatorios, true);
    const obligatorios  = await this.canalPasoService.bulk( pasosObligatorios ).toPromise();
    obligatorios.map( cp => {
      cp.flujoVentaPaso = this.listaPasosFlujoVenta.find( x => x.idFlujoVentaPaso === cp.idFlujoVentaPaso ).nombre;
      cp.codigoPasoFlujo = this.listaPasosFlujoVenta.find( x => x.idFlujoVentaPaso === cp.idFlujoVentaPaso ).codigo;
      this.listaPasosCanal.push(cp);
    });
    console.log('Pasos obligatorios guardados');
    /*this.canalPasoService.bulk( pasosObligatorios ).subscribe( resp => {
      resp.map( cp => {
        cp.pasoFlujoVenta = this.listaPasosFlujoVenta.find( x => x.idFlujoVentaPaso === cp.idFlujoVentaPaso ).nombre;
        cp.codigoPasoFlujo = this.listaPasosFlujoVenta.find( x => x.idFlujoVentaPaso === cp.idFlujoVentaPaso ).codigo;
        this.listaPasosCanal.push(cp);
      });
      console.log('Pasos obligatorios guardados');
    });*/
  }

 async editarControles(record: ConfiguracionCanalFlujoVentaPaso) {
    // SE TIENE QUE ABRIR EL MODAL PARA LA EDICION DE CONTROLES DEL PASO
    this.cargandoControles = true;
    this.pasoPolitica = false;
    if(record.codigoFlujoVentaPaso === Pasos.POLITICA) {
      this.configCanalPasoControl = record;
      this.showConfigControls = true;
      this.cargandoControles = false;
      this.pasoPolitica = true;
    } else {
       const controles = this.listaFlujoVentaPasoControl.filter( x => x.idFlujoVentaPaso === record.idFlujoVentaPaso);
       if (controles && controles.length === 0) {
         this.showMessage('LBL_INFORMACION', 'El paso no tiene controles configurados!', 'info');
         this.cargandoControles = false;
       } else {
         this.configCanalPasoControl = record;
         this.showConfigControls = true;
         this.cargandoControles = false;
       }
    }

  }

  inhabilitarPasoCanal(record: ConfiguracionCanalFlujoVentaPaso) {
    this.conServicio.confirm( {
      message: this.navServicio.buscarMensaje( 'CONFIGURACIONCANALESESTADO.MSG_ELIMINARPASO' ),
      header: this.navServicio.buscarMensaje( 'LBL_CONFIRMACION' ),
      icon: 'fa fa-question-circle',
      accept: () => {
        record.indicadorHabilitado = false;
        this.canalPasoService.actualizar(record).subscribe( resp => {
          this.showMessage('LBL_INFORMACION', 'Se ha eliminado el paso de forma exitosa!', 'success');
          this.cargarItemsValidos();
        });
      },
      reject: () => {
      }
    } );
  }

  cerrarModal() {
    this.conServicio.confirm( {
      message: this.navServicio.buscarMensaje( 'CONFIGURACIONCANALESESTADO.MSG_CERRARMODAL' ),
      header: this.navServicio.buscarMensaje( 'LBL_CONFIRMACION' ),
      icon: 'fa fa-question-circle',
      accept: () => {
        this.showConfigControls = false;
      },
      reject: () => {
      }
    } );
  }

}
